import { getUserConfiguration } from 'owa-session-store';

export const getAllOnboardingCardsShownStatus = () => {
    const primeSettings = getUserConfiguration()?.PrimeSettings;

    const onboardingCampaignOptions = primeSettings?.Items?.find(
        primeSetting => primeSetting.Id === 'OnboardingCampaignOptions'
    );

    const allOnboardingCardsShown: boolean =
        (onboardingCampaignOptions?.Value?.options?.[0]?.allOnboardingCardsShown as any) || false;

    return allOnboardingCardsShown;
};
